<template>
  <tr
    class="text-xs"
    :class="
      type === 'portfolio-component'
        ? 'dark:bg-ontick-graphite-600 bg-ontick-steel-200'
        : 'dark:bg-ontick-graphite-500 bg-ontick-steel-100'
    "
  >
    <td class="td">
      <div>
        <span>
          {{ data.strategy_name }}
        </span>
      </div>
    </td>
    <td class="td">
      <div>
        <ontick-symbol-pill-component :symbol="data.position_symbol" />
      </div>
    </td>
    <td class="td">
      <div>
        <ontick-position-pill-component :position_status="data.position_status" />
        <span class="text-ontick-graphite-500 font-semibold dark:text-gray-300">
          {{ data.position_volume }}
        </span>
      </div>
    </td>
    <td class="td">
      <div>
        {{ moment(data.position_time).format("DD/MM/YYYY - HH:mm:ss") }}
      </div>
    </td>
    <td class="td">
      <div>
        {{ data.position_price }}
      </div>
    </td>
    <td class="td">
      <div>
        {{ data.position_sl }}
      </div>
    </td>
    <td class="td">
      <div>
        {{ data.position_tp }}
      </div>
    </td>
    <td class="td">
      <div>
        <i
          v-html="$icons.error"
          v-if="connectionStatus.error"
          content="Erro na conexão. Atualize a página para tentar novamente."
          v-tippy="{ arrow: true, theme: 'red' }"
        ></i>
        <template v-else>
          <i
            v-html="$icons.loading"
            v-if="connectionStatus.awaitingConnection || data.open_pnl === null"
            class="text-ontick-blue-600"
            :content="spinnerTooltip(connectionStatus.awaitingConnection, data.open_pnl === null)"
            v-tippy="{ arrow: true, theme: 'green' }"
          ></i>
          <i
            v-else-if="data.open_pnl != 0"
            :class="
              data.open_pnl > 0
                ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
                : 'text-ontick-red-500 rotate-180'
            "
            v-html="$icons.arrow_drop"
          ></i>
          <span class="dark:text-gray-300" v-if="!(connectionStatus.awaitingConnection || data.open_pnl === null)">
            {{ data.open_pnl | currency }}
          </span>
        </template>
      </div>
    </td>
    <td class="td">
      <div>
        {{ data.position_comment }}
      </div>
    </td>
  </tr>
</template>

<script>
import OntickPositionPillComponent from "../../../../shared/components/basic/ontick-position-pill.component.vue";
import OntickSymbolPillComponent from "../../../../shared/components/basic/ontick-symbol-pill.component.vue";
export default {
  props: {
    data: {
      type: Object,
    },
    type: {
      type: String,
    },
    connectionStatus: {
      type: Object,
    },
  },

  components: {
    OntickPositionPillComponent,
    OntickSymbolPillComponent,
  },
  methods: {
    spinnerTooltip(awaitingConnection, awaitingData) {
      if (awaitingConnection) {
        return "Aguardando conexão...";
      } else if (awaitingData) {
        return "Aguardando dados atualizados...";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
td {
  @apply gap-1 py-2 px-4 text-gray-600 dark:text-gray-400;
  & > div {
    @apply flex items-center gap-1;
  }
}
</style>
